import styled from "styled-components";
import { FeatureState } from "../store/chart";
import { FontWeight } from "../types";
import { Text } from "./Text";
import { ReactComponent as TooltipIcon } from "../assets/images/tooltip.svg";
import { Tooltip } from "./Tooltip";

type FeatureProps = {
  className?: string;
  feature: FeatureState;
  legalCopyArray: string[];
};

export function Feature({ className, feature, legalCopyArray }: FeatureProps) {
  let legacyCopy;
  if (feature.legalCopy) {
    const index = legalCopyArray.indexOf(feature.legalCopy);
    legacyCopy = index >= 0 ? <sup>{index + 1}</sup> : null;
  }
  return (
    <div className={className}>
      {feature.icon && (
        <FeatureIcon src={feature.icon.url} alt={feature.icon.alt} />
      )}
      <FeatureName>
        {feature.name}
        {legacyCopy}
      </FeatureName>
      {feature.tooltip.visible && feature.tooltip.description && (
        <Tooltip label={feature.tooltip.description}>
          <FeatureTooltipToggle>
            <TooltipIcon />
          </FeatureTooltipToggle>
        </Tooltip>
      )}
    </div>
  );
}

export const FeatureName = styled(Text)`
  &&& {
    font-weight: ${({ theme }) =>
      theme.isMobile ? FontWeight.Normal : FontWeight.SemiBold};
    font-size: ${({ theme }) =>
      theme.isMobile ? theme.getFontSize(16) : theme.getFontSize(22)}px;
    line-height: 1;
    margin: 0;
    text-align: ${({ theme }) => (theme.isMobile ? "center" : "left")};

    sup {
      font-size: ${({ theme }) =>
        theme.isMobile ? theme.getFontSize(10) : theme.getFontSize(12)}px;
    }
  }
`;

const FeatureIcon = styled.img`
  display: block;
  height: ${({ theme }) =>
    theme.isMobile ? theme.getValue(20) : theme.getValue(35)}px;
  width: auto;
  max-width: 100%;
  margin: ${({ theme }) =>
    theme.isMobile
      ? `0 auto ${theme.getValue(4)}px`
      : `0 0 ${theme.getValue(10)}px`};
`;

const FeatureTooltipToggle = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) => theme.getValue(23)}px;
  height: ${({ theme }) => theme.getValue(23)}px;
  margin: ${({ theme }) =>
    theme.isMobile
      ? `${theme.getValue(6)}px auto 0`
      : `${theme.getValue(10)}px 0 0`};
  padding: 0;
  cursor: pointer;
  border: 0;
  background: none;
  appearance: none;

  svg {
    display: block;
    width: ${({ theme }) => theme.getValue(23)}px;
    height: ${({ theme }) => theme.getValue(23)}px;
  }
`;
